/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：740
 */

"use strict"

var r = require(/* 325 */"../325")
var i = require(/* 1504 */"./1504")
var o = "object" == typeof exports && exports && !exports.nodeType && exports
var a = o && "object" == typeof module && module && !module.nodeType && module
var s = a && a.exports === o ? r.a.Buffer : undefined
var c = (s ? s.isBuffer : undefined) || i.a
exports.a = c
